import React from 'react';
import { Control } from 'react-hook-form';
import cls from 'classnames';

import { l10n } from '@ott/l10n';

import { FormState } from '../../types';

import { EARLY_CHECKIN_ITEMS, LATE_CHECKOUT_ITEMS } from '../../constants';
import TimeDropdown from './blocks/TimeDropdown';

import styles from './TimePicker.scss';

interface Props {
  control: Control<FormState>;
  theme: 'dark' | 'light';
  canSpecifyCheckinTime: boolean;
  triggerClassName?: string;
}

const TimePicker: React.FC<Props> = (props) => {
  const { control, theme = 'light', canSpecifyCheckinTime, triggerClassName }: Props = props;

  return (
    <div className={cls(styles.TimePicker, triggerClassName)}>
      {canSpecifyCheckinTime && (
        <div className={styles.field}>
          <TimeDropdown
            name="earlyCheckin"
            control={control}
            caption={l10n('hotelsSearchForm.earlyCheckIn')}
            isDark={theme === 'dark'}
            triggerClassName={styles.trigger}
            testLocator="early-checkin-input"
            items={EARLY_CHECKIN_ITEMS}
          />
        </div>
      )}
      <div className={styles.field}>
        <TimeDropdown
          name="lateCheckout"
          control={control}
          caption={l10n('hotelsSearchForm.lateCheckout')}
          isDark={theme === 'dark'}
          testLocator="late-checkout-input"
          triggerClassName={styles.trigger}
          items={LATE_CHECKOUT_ITEMS}
        />
      </div>
    </div>
  );
};

export default TimePicker;
